export default __webpack_public_path__ + "static/media/github.c38280f5.png";